__turbopack_context__.v({
  "container": "styles-module__OypEbG__container",
  "selected": "styles-module__OypEbG__selected",
  "tab": "styles-module__OypEbG__tab",
});
